import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import VueHtml2Canvas from "vue-html2canvas";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faStar,
  faChartBar,
  faTrophy,
  faEnvelopeOpen,
  faEnvelope,
  faPlay,
  faHeart,
  faQuestion,
  faCheck,
  faHeadphones,
  faHome,
  faAngleRight,
  faComment,
  faLink,
  faWrench,
  faDesktop,
  faStopwatch,
  faRedo
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import firebase from "firebase";
import KakaoSDK from "./plugins/KakaoSDK";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import ProgressBar from "vue-simple-progress";
/* page */
import HomePage from "./pages/home/index.vue";
import WorldCupPage from "./pages/world-cup/index.vue";
import RandomMusicPage from "./pages/random-music/index.vue";
import MovieQuizPage from "./pages/movie-quiz/index.vue";
import VisitorPage from "./pages/visitor/index.vue";
import RankingPage from "./pages/ranking/index.vue";
import ContactPage from "./pages/contact/index.vue";
import AuthTestPage from "./pages/auth-test/index.vue";
import NotFoundPage from "./pages/not-found/index.vue";
import MathsPage from "./pages/maths/index.vue";
import OneToFiftyPage from "./pages/onetofifty/index.vue";
import findColorPage from "./pages/find-color/index.vue";
import MineSweeperPage from "./pages/mine-sweeper/index.vue";
import English1Page from "./pages/english1/index.vue";
import SocialSharing from "vue-social-sharing";

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(SocialSharing);
Vue.use(KakaoSDK);
Vue.use(VueHtml2Canvas);

library.add(
  faEnvelopeOpen,
  faChartBar,
  faEnvelope,
  faTrophy,
  faStar,
  faPlay,
  faHeart,
  faQuestion,
  faCheck,
  faHeadphones,
  faHome,
  faAngleRight,
  faComment,
  faLink,
  faWrench,
  faDesktop,
  faStopwatch,
  faRedo
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

const config = {
  /*
  apiKey: "AIzaSyAyscuMFjUF54CvMYePMS8zde-Oz8bZT10",
  authDomain: "natural-cistern-278013.firebaseapp.com",
  databaseURL: "https://natural-cistern-278013.firebaseio.com",
  projectId: "natural-cistern-278013",
  storageBucket: "natural-cistern-278013.appspot.com",
  messagingSenderId: "1007348410169",
  appId: "1:1007348410169:web:779b5d6ce5958140d9eae8",
  measurementId: "G-HLVRG8W75G"
  */
  apiKey: "AIzaSyBqcJY7r6jO_8gaDV6UvLaMipbWHmGr4D8",
  authDomain: "spready-6315d.firebaseapp.com",
  databaseURL: "https://spready-6315d-default-rtdb.firebaseio.com",
  projectId: "spready-6315d",
  storageBucket: "spready-6315d.appspot.com",
  messagingSenderId: "19613167133",
  appId: "1:19613167133:web:900805dcd91573b91c20f4"
};

firebase.initializeApp(config);

const routes = [
  { path: "/", component: HomePage },
  { path: "/world-cup", component: WorldCupPage },
  { path: "/random-music", component: RandomMusicPage },
  { path: "/movie-quiz", component: MovieQuizPage },
  { path: "/visitor", component: VisitorPage },
  { path: "/ranking", component: RankingPage },
  { path: "/contact", component: ContactPage },
  { path: "/auth-test", component: AuthTestPage },
  { path: "/maths", component: MathsPage },
  { path: "/onetofifty", component: OneToFiftyPage },
  { path: "/find-color", component: findColorPage },
  { path: "/mine-sweeper", component: MineSweeperPage },
  { path: "/english1", component: English1Page },
  { path: "*", component: NotFoundPage }
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

new Vue({
  router,
  vuetify,
  ProgressBar,
  render: h => h(App)
}).$mount("#app");
